import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-single_scene",
  "use": "icon-single_scene-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-single_scene\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M17.33,5.33A.67.67,0,0,1,18,6V18a.67.67,0,0,1-.67.67H6.67A.67.67,0,0,1,6,18V6a.67.67,0,0,1,.67-.67Zm-.66,1.34H7.33V17.33h9.34Zm-2,8V16H9.33V14.67ZM12,8a2.67,2.67,0,1,1-2.67,2.67A2.67,2.67,0,0,1,12,8Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol